
import { Mark } from "tiptap";
import { updateMark } from 'tiptap-commands';

const REGEX_COLOR = /[;]{0,1}\s*color\s*[:]\s*((rgb\s*\([0-9, ]+\))|([#][a-fA-F0-9]+)|([a-zA-Z0-9]+))\s*[;]{0,1}/ig;
const REGEX_RGB = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/ig;
const fnHex = (num, pad = 2) => {
  let str = parseInt(num).toString(16);
  for (let ln = str.length; ln < pad; ln++) {
    str = "0" + str;
  }
  // console.log("STR:" + str);
  return str;
};

const GET_ATTRS = (dom) => {
  let userData = [];
  for(let ninx = 0, attrs = dom.attributes; ninx < attrs.length; ninx++) {
    let key = attrs[ninx].name;
    if (
      key.length > 5 && key.substring(0, 5) === "data-" &&
      !(key.length > 7 && key.substring(0, 7) === "data-v-")) {
      // console.log("KV:", key, dom.getAttribute(key));
      userData.push({ key: key, value: dom.getAttribute(key) });
    }
  }
  let atr_id = dom.getAttribute("id");
  let atr_tag = dom.nodeName.toLowerCase();
  let atr_class = dom.getAttribute("class");
  let atr_style = dom.getAttribute("style");
  let atr_color = "";
  {
    let mats = REGEX_COLOR.exec(atr_style);
    // console.log("MAT:", mats);
    if (mats && mats.length > 1) {
      atr_color = mats[1];
      atr_color = atr_color.replace(/^\s*/g, "");
      atr_color = atr_color.replace(/\s*$/g, "");
      mats = REGEX_RGB.exec(atr_color);
      // console.log("RGB:", atr_color, mats);
      if (mats && mats.length > 3) {
        atr_color = "#" + fnHex(mats[1]) + fnHex(mats[2]) + fnHex(mats[3]);
        // console.log("COLOR:", atr_color);
      }
      /* 아래 구문을 빼면 정상적으로 작동하지 않음 (Vue 버그?) */
      mats = REGEX_RGB.exec(atr_color);
    }
  }
  if (atr_style) {
    atr_style = atr_style.replace(REGEX_COLOR, ";");
    atr_style = atr_style.replace(/^\s*;\s*/g, "");
    atr_style = atr_style.replace(/\s*;\s*$/g, "");
  }
  // console.log("STYLE:", atr_style, atr_color);
  let ret = { };
  if (atr_id) { ret.id = atr_id; }
  if (atr_tag) { ret.tag = atr_tag; }
  if (atr_class) { ret.class = atr_class; }
  if (atr_style) { ret.style = atr_style; }
  if (atr_color) { ret.color = atr_color; }
  if (userData.length > 0) { ret.userData = userData; }
  // console.log("PARSE:", ret);
  return ret;
};

export default class SpanElement extends Mark {
  get name() {
    return "span_element";
  }

  get schema() {
    return {
      content: "block*",
      group: "block",
      selectable: false,
      draggable: false,
      atom: true,
      attrs: {
        id: { default: null },
        tag: { default: "span" },
        class: { default: null },
        style: { default: null },
        color: { default: null },
        userData: { default: [] },
      },
      parseDOM: [
        {
          tag: "span",
          getAttrs(dom) { 
            let ret = GET_ATTRS(dom);
            return ret;
          }
        },
      ],
      toDOM: (mark) => {
        // console.log("TODOM:", mark.attrs.tag, mark.attrs);
        let attrs = { };
        let style = "";
        if (mark.attrs.id) { attrs.id = mark.attrs.id; }
        if (mark.attrs.class) { attrs.class = mark.attrs.class; }
        if (mark.attrs.style) { style = mark.attrs.style; }
        if (mark.attrs.color) {
          if (style) {
            style = style.replace(REGEX_COLOR, ";");
            style = style.replace(/^\s*;\s*/, "");
            style = style.replace(/\s*;\s*$/, "");
          }
          if (mark.attrs.color != "none") {
            if (style) { style += "; "; }
            style += "color:" + mark.attrs.color;
          }
        }
        if (style) { attrs.style = style; }

        if (mark.attrs.userData) {
          mark.attrs.userData.forEach(item => {
            attrs[item.key] = item.value;
          });
        }
        // console.log("ATTRS:", attrs);
        return [
          mark.attrs.tag, 
          attrs,
          0
        ];
      }
    };
  }

  commands ({ type }) {
    type.rank = 2; // <span>이 밑줄,취소선(<u>,<s>)을 감싸게 하기 위해 우선순위 설정 (<span><u><s></span> 구성)
    return (attrs) => updateMark(type, attrs)
  }

//   inputRules({ type }) {
//     return [
//       markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
//     ]
//   }
}


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/extensions/SpanElement.js